import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Subjects from '../pages/subjects';
import Classes from '../pages/classes';
import Credits from '../pages/credits';

export default function Routing() {
  return (
    <Routes>
      <Route path="/:subject/:page/:section?" element={<Classes />} />
      <Route path="/expediente" element={<Credits />} />
      <Route path="/" element={<Subjects />} />
      <Route path="*" element={<Subjects />} />
    </Routes>
  );
}
